<template>
  <section class="root">
    <div style="text-align: center;" v-if="currentReview">
      <blockquote>"{{ currentReview.quote }}"</blockquote>
      <img v-if="currentReview.image?.filename" :src="transformImage(currentReview.image.filename, '100x100', true)" :alt="currentReview.name" width="80"
        height="80">
      <p class="name">
        {{ currentReview.name }}
      </p>
      <div class="cycle">
        <span @click="prevReview" class="arrow">
          <cms-material-icon class="icon" style="color:var(--crf-text)" icon="chevron_left"></cms-material-icon>
        </span>
        <span>{{ currentItem }} / {{ reviewCount }}</span>
        <span @click="nextReview" class="arrow">
          <cms-material-icon class="icon" style="color:var(--crf-text)" icon="chevron_right"></cms-material-icon>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-review-carousel",
  computed: {
    reviewCount() {
      return this.blok.reviews.length;
    },
    currentReview() {
      return this.blok.reviews[this.currentItem - 1];
    },
  },
  methods: {
    nextReview() {
      if (this.currentItem + 1 > this.reviewCount) {
        this.currentItem = 1;
      } else {
        this.currentItem++;
      }
    },
    prevReview() {
      if (this.currentItem - 1 < 1) {
        this.currentItem = this.reviewCount;
      } else {
        this.currentItem--;
      }
    },
  },
  data() {
    return {
      currentItem: 1,
    };
  },
};
</script>

<style scoped>
img {
  display: block;
  margin: 0 auto;
  width: 80px;
  border-radius: 50%;
}

div.cycle {
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 160px;
  font-weight: 600;
  font-size: 13px;
  line-height: 28px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  margin-top: 2rem;
  margin-inline: auto;
  padding: 0.25rem 0;
  color: var(--crf-text);
  background: var(--crf-bg-high);
}

.arrow {
  display: flex;
  place-items: center;
  cursor: pointer;
  padding: 0.5rem;
}

.arrow .icon {
  cursor: pointer;
}

blockquote {
  color: var(--crf-text);
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 27px;
  text-align: center;
  max-width: 700px;
  max-width: 60ch;
  margin: 0 auto 2rem auto;
  min-height: 52px;
  overflow-y: hidden;
}

p.name {
  color: var(--crf-text);
  text-align: center;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 20px;
  margin-top: 1rem;
}
</style>
